import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-id-info',
  templateUrl: './id-info.component.html',
  styleUrls: ['./id-info.component.scss']
})
export class IdInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
